export enum CompleteReasonTypeEnum {
	None = 0,
	NoSignal = 1,
	WrongPin = 2,
	GrayButtonCantSwipe = 3,
	LowBattery = 4,
	Other = 100
}
